import updateState from './updateState';
import Swal from 'sweetalert2';
const setUserMaterials = (state, materialsArray) => {
  state.userMaterials = materialsArray
}

// O material guarda o índice de refração n; os solvers usam a permissividade relativa ε = n²
const materialEpsilon = (material) => {
  const n = Number(material.refraction_index);
  return n * n;
}

const setMaterialForm = (state, status) => {
  state.materialForm = status
}

// Fundo padrão da célula: vácuo (epsilon = 1)
const DEFAULT_CELL = {
  fill: '#ffffff',
  epsilon: 1,
  material_id: 0,
  materialTitle: 'Default Material',
  materialDescription: 'This is the default material'
}

const resetCellMaterial = (state) => {
  state.default_material = DEFAULT_CELL.epsilon;
  state.cell = { ...DEFAULT_CELL };
  notify(state, 'Cell background reset to vacuum (ε = 1)', true);
}

// Aviso no rodapé do simulador (Navbar); undo = mostra o botão "Undo"
const notify = (state, text, undo = false) => {
  state.notice = { id: state.notice.id + 1, text, undo };
}

// Carrega o fundo salvo. Simulações antigas só têm default_material:
// se ele não for o padrão, o fundo ganha uma cor para a mudança não ficar invisível
const loadCellMaterial = (state, data) => {
  const epsilon = Number(data.default_material) || DEFAULT_CELL.epsilon;
  state.default_material = epsilon;
  if (data.cell) {
    state.cell = { ...DEFAULT_CELL, ...data.cell, epsilon };
  } else if (epsilon !== DEFAULT_CELL.epsilon) {
    state.cell = {
      ...DEFAULT_CELL,
      fill: '#d9d9d9',
      epsilon,
      materialTitle: 'Custom background',
      materialDescription: 'Background material of the cell'
    };
  } else {
    state.cell = { ...DEFAULT_CELL };
  }
}


const setMaterialOfCurrentGeometry = (state, material) => {
  try {
    if (state.selectedToken === '') {
      // O 3D não tem fundo (o domínio é ar): sem geometria selecionada, só orienta o usuário
      if (state.is3d) {
        notify(state, 'Select a geometry first to change its material');
        return;
      }
      // 2D: sem geometria selecionada o material vira o fundo da célula. Antes isso acontecia em
      // silêncio e o usuário só percebia depois; agora avisa e oferece desfazer
      state.default_material = materialEpsilon(material)
      state.cell.fill = material.color;
      state.cell.materialTitle = material.title;
      state.cell.materialDescription = material.description;
      state.cell.epsilon = state.default_material;
      state.cell.material_id = material._id;
      notify(state, `Cell background set to “${material.title}”`, true);
      updateState(state);
      return;
    }

    if (state.mode === "miniCanvas") {
      let e_local = {};
      state.GeometryList.forEach((e) => {
        if (e.token == state.selectedToken) {
          e_local = e;
        }
      });

      e_local.geometricFillPattern.forEach((e) => {
        if (e.token == state.selectedInsideToken) {
          e.materialId = material._id;
          e.fill = material.color;
          e.epsilon = materialEpsilon(material);
        }
      });

      return;
    }

    state.GeometryList.forEach((e) => {
      if (e.token == state.selectedToken) {
        e.materialId = material._id;
        e.fill = material.color;
        e.epsilon = materialEpsilon(material);
        e.materialTitle = material.title;
        e.materialDescription = material.description;
      }
    });
    updateState(state);

  } catch (err) {
    Swal.fire({ title: 'An error appears', text: err.message });
  }
}

export {
  setUserMaterials,
  setMaterialForm,
  setMaterialOfCurrentGeometry,
  resetCellMaterial,
  loadCellMaterial,
}